import { useEffect, useState } from 'react';
import { validateFileUpload } from '../../helper/validateFileUpload';
import { useUploadFile } from '../../hooks/useUploadFile';

const MultipleFileInput = ({ files, fieldName, isMultiple = true, onUploaded, onRemoved }) => {
    const defaultMaxFileSize = 2 * 1024 * 1024; // 2MB in bytes
    const defaultAllowedFileType = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml'];
    const { uploadMultiple, data: uploadData, status: uploadStatus, error: uploadError, resetUploadStatus } = useUploadFile();
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isFile, setIsFile] = useState(false);
    const [isAttachmentLoading, setIsAttachmentLoading] = useState(false);
    const [error, setError] = useState({});

    const onProfileImageChange = (event, onUploaded) => {
        const _file = event.target.files;
        const filesArray = Array.from(_file || []);
        if (_file) {
            // validate each filesArray
            const filesValidatorResult = filesArray.map((file) =>
                validateFileUpload({
                    file,
                    fieldName,
                    maxFileSize: defaultMaxFileSize,
                    allowedFileType: defaultAllowedFileType
                })
            );

            const errorFiles = filesValidatorResult.filter((result) => result.isError);
            const validFiles = filesValidatorResult.filter((result) => !result.isError);

            const _uploadedFileArray = filesArray.filter((file, index) => !filesValidatorResult[index].isError);
            const _uploadedFiles = { ..._uploadedFileArray };

            if (errorFiles.length > 0) {
                setError({
                    name: errorFiles.map((error) => error.name).join(', '),
                    isError: true,
                    message: errorFiles.map((error) => error.message).join(', ')
                });
            }

            if (validFiles.length > 0) {
                setUploadProgress(0);
                setIsAttachmentLoading(true);

                let formData = new FormData();

                if (errorFiles.length === 0) {
                    setError({
                        isError: false,
                        message: '',
                        name: fieldName
                    });
                }

                _uploadedFileArray.forEach((file) => {
                    formData.append('files', file);
                });
                uploadMultiple(formData)
                    .then((result) => {
                        setIsAttachmentLoading(false);
                        setIsFile(true);
                        onUploaded(result); // ✅ use result directly
                    })
                    .catch(() => {
                        setIsAttachmentLoading(false);
                        setIsFile(false);
                        onUploaded([]);
                    });
            }
        }
    };

    const onRemoveFiles = (file) => {
        if (!isMultiple) {
            setIsFile(false);
        }
        onRemoved && onRemoved(file);
    }

    // useEffect(() => {
    //     console.log('uploadStatus', uploadStatus);
    //     if (uploadStatus === 'done') {
    //         setIsAttachmentLoading(false);
    //         setIsFile(true);
    //         onUploaded(uploadData);
    //     } else if (uploadStatus === 'error') {
    //         onUploaded([]);
    //         setIsAttachmentLoading(false);
    //         setIsFile(false);
    //     }
    // }, [uploadStatus, uploadData]);

    useEffect(() => {
        if (files && files.length > 0) {
            setIsFile(true);
        }
    }, [files]);

    return (
        <div className="">
            {/* File Grid */}
            <div className="d-flex flex-wrap gap-2 w-100">
                <div
                    className="d-grid"
                    style={{ gridTemplateColumns: "repeat(auto-fill, minmax(256px, 1fr))", gap: "8px", width: "100%" }}
                >
                    {files &&
                        files.length > 0 &&
                        files.map((file, index) => (
                            <div
                                key={index}
                                className="me-2 mb-2 position-relative"
                                style={{ width: "256px", height: "auto" }}
                            >
                                <img
                                    src={file.url ? file.url : ""}
                                    alt="User"
                                    className="img-thumbnail"
                                    style={{ width: "256px", height: "256px", objectFit: "cover", borderRadius: "0.375rem", marginBottom: "0.5rem" }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger w-100"
                                    onClick={() => onRemoveFiles(file)}
                                >
                                    <i class="ph ph-trash"></i>
                                </button>
                            </div>
                        ))}
                </div>

                {/* Upload Button */}
                <div className="mt-2">
                    <label
                        htmlFor="containedButtonFile"
                        style={{
                            display:
                                files && files.length > 0 && isFile && isMultiple === false ? "none" : "inline-block",
                        }}
                    >
                        <input
                            accept="image/*"
                            id="containedButtonFile"
                            type="file"
                            multiple={isMultiple}
                            //onChangeCapture={(e) => onProfileImageChange(e, onUploaded)}
                            onChange={(e) => onProfileImageChange(e, onUploaded)}
                            style={{
                                opacity: 0,
                                position: "absolute",
                                zIndex: 99,
                                cursor: "pointer",
                                width: "256px",
                                height: "256px",
                            }}
                        />
                        <button
                            type="button"
                            className="btn border border-main-one-600 text-main-one-600 d-flex align-items-center justify-content-center"
                            style={{ width: "256px", height: "256px" }}
                            disabled={isAttachmentLoading}
                        >
                            <i className="bi bi-upload me-1"></i>
                            {isAttachmentLoading
                                ? `Uploading File...`
                                : "Upload File"}
                        </button>
                    </label>
                </div>
            </div>

            {/* Caption */}
            <div className="mt-2">
                <small
                    className={
                        error.name === fieldName && error.isError
                            ? "text-danger"
                            : "text-secondary"
                    }
                >
                    <i className="bi bi-info-circle me-1"></i>
                    {error.name === fieldName && error.isError
                        ? error.message
                        : "Image size limit should be 2MB max."}
                </small>
            </div>
        </div>

    );
}

export default MultipleFileInput;